module.exports = __webpack_public_path__ + "img/vegetable-celery-root-350x184.cc4bcca9.jpg";